module.exports = __webpack_public_path__ + "static/media/2002_Population_totalRate.a76142b6.png";